/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{margin:0;height:100%}.um[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
